<div class="btn-container">
  <p class="step-title">{{ 'symptomAssessment.symptomDetails.valutation_details' | translate}}</p>
  <ds-button [width]="'small'" class="consulta-medico" [text]="'symptomAssessment.symptomDetails.button_consult' | translate" (click)="medicalConsultation()"> </ds-button>
  <p style="margin-bottom: 10px">{{ 'symptomAssessment.symptomDetails.number_text' | translate}}</p>
  <ng-container> </ng-container>
  <ds-select [placeholder]="'symptomAssessment.symptomDetails.select_emergency_number' | translate" [texts]="countryDescriptions" [values]="countryIds" [control]="emergencyForm?.get('destination')"></ds-select>

  <ds-button [width]="'small'" class="emergency-button" (click)="callToEmergency()" [text]="('symptomAssessment.symptomDetails.call_btn' | translate) + (selectedCountryNumber || '')"> </ds-button>
</div>

<div class="summary-container" id="print-section">
  <div *ngIf="diagnosis.diagnoses && diagnosis.diagnoses.length">
    <p class="title">{{'symptomAssessment.symptomDetails.analisi' | translate}}</p>
    <div *ngFor="let probability of diagnosis.diagnoses">
      <ul>
        <li class="text">{{ probability.label }} {{ probability.probability }}%</li>
      </ul>
    </div>
  </div>
  <div *ngFor="let content of diagnosis.contents">
    <p class="title">{{ content.title }}</p>
    <p class="text" [innerHTML]="content.text"></p>
    <div *ngIf="content.contents && content.contents.length">
      <div *ngFor="let subContent of content.contents">
        <p class="title-contents">{{ subContent.title }}</p>
        <p class="text-contents" [innerHTML]="subContent.text"></p>
      </div>
    </div>
  </div>
  <div class="button-container">
    <ds-button style="margin-right: 10px" [text]="'CHIUDI'" [styleType]="'empty-main'" [width]="'small'" (click)="back()"></ds-button>
    <ds-button *ngIf="!onMobile" [text]="'STAMPA'" [width]="'small'" (click)="printSection()"></ds-button>  </div>
</div>
